var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8815 16.3704C16.8815 14.6931 18.2413 13.3333 19.9186 13.3333C21.5959 13.3333 22.9556 14.6931 22.9556 16.3704C22.9556 18.0477 21.5959 19.4074 19.9186 19.4074C18.2413 19.4074 16.8815 18.0477 16.8815 16.3704ZM19.9186 12C17.5049 12 15.5482 13.9567 15.5482 16.3704C15.5482 18.7841 17.5049 20.7407 19.9186 20.7407C22.3323 20.7407 24.2889 18.7841 24.2889 16.3704C24.2889 13.9567 22.3323 12 19.9186 12ZM19.9185 21.6296C16.1738 21.6296 12.8889 24.1251 12.8889 27.4815C12.8889 27.8497 13.1874 28.1481 13.5556 28.1481C13.9238 28.1481 14.2222 27.8497 14.2222 27.4815C14.2222 25.1044 16.6411 22.9629 19.9185 22.9629C23.196 22.9629 25.6148 25.1044 25.6148 27.4815C25.6148 27.8497 25.9133 28.1481 26.2815 28.1481C26.6497 28.1481 26.9482 27.8497 26.9482 27.4815C26.9482 24.1251 23.6633 21.6296 19.9185 21.6296Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.a03658cd84a0c97ac2a71d2326ba390f.svg";
export { ForwardRef as ReactComponent };